import { HStack, LucideIcon, Text } from '@skin-seoul/design-system';
import React from 'react';
import { useProductCompareContext, type FilterType } from '../context';
import { trackFilterClick } from '../utils/analytics';
const FILTER_OPTIONS: Array<{
  label: string;
  value: FilterType;
  analyticsName: 'more_reviews' | 'lower_price';
}> = [{
  label: 'More Reviews',
  value: 'moreReviews',
  analyticsName: 'more_reviews'
}, {
  label: 'Lower Price',
  value: 'lowerPrice',
  analyticsName: 'lower_price'
}];
const ProductFilterList = () => {
  const {
    selectedFilter,
    setSelectedFilter
  } = useProductCompareContext();
  const handleFilterClick = (filterValue: FilterType, analyticsName: 'more_reviews' | 'lower_price') => {
    const isCurrentlySelected = selectedFilter === filterValue;
    setSelectedFilter(prev => prev === filterValue ? undefined : filterValue);
    if (!isCurrentlySelected) {
      trackFilterClick(analyticsName);
    }
  };
  return <HStack width="100%" gap={2} paddingX={{
    base: 4,
    tablet: 0
  }} alignItems="center" data-sentry-element="HStack" data-sentry-component="ProductFilterList" data-sentry-source-file="ProductFilterList.tsx">
      <LucideIcon display={{
      base: 'none',
      tablet: 'block'
    }} name="SlidersHorizontal" boxSize={5} color="generic.100" data-sentry-element="LucideIcon" data-sentry-source-file="ProductFilterList.tsx" />
      {FILTER_OPTIONS.map(option => {
      const isSelected = selectedFilter === option.value;
      return <Text key={option.value} px={2.5} py={1} bg={isSelected ? 'neutral.75' : 'neutral.50'} border="1px solid" borderColor={isSelected ? 'neutral.100' : 'neutral.50'} borderRadius={20} textStyle="paragraph.small" fontWeight="regular" color="neutral.600" cursor="pointer" transition="all 0.2s" onClick={() => handleFilterClick(option.value, option.analyticsName)}>
            {option.label}
          </Text>;
    })}
    </HStack>;
};
export default ProductFilterList;